module.exports = __webpack_public_path__ + "img/rebit_logo_noBG.5a2c5a35.png";